import React, { useContext, useState } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Row, Col, Modal} from "react-bootstrap";
import {  LabelFieldComponent } from "../../components/fields";
import { ButtonComponent } from "../../components/elements";
import PageLayout from "../../layouts/PageLayout";
import PulseLoader from "react-spinners/PulseLoader";
import { addCountryData } from "../../APIs/SettingRequests";
import { toast } from 'react-toastify';
import TextWithIconFieldComponent from "../../components/fields/TextWithIconFieldComponent";

export default function CountryCreatePage() {


    const { t } = useContext(TranslatorContext);
    const [country, setCountry] = useState('');
    const [city, setCity] = useState('');
    const [state, setState] = useState('');
    const [states, setStates] = useState([]);
    const [alertModal, setAlertModal] = useState(false);
    const [currentStateIndex, setCurrentStateIndex] = useState(0);

    const [loading, setLoading] = useState(false);
    
    const handleAddState = () => {
        if(state !== ''){
            setStates([...states, state]);
            setState('');
        }else{
            const notify = () => toast.success(t('state_name_required'));
            notify();
        }
    }
    const handleSubmit = () => {
        setLoading(true)
        addCountryData(country, city, states).then((res) => {
            //console.log(res.data.data);
            setStates([]);
            setCity('');
            setCountry('');
            setState('');
            const notify = () => toast.success(res.data.message);
            notify();
        }).catch((error) => {
            console.log(error);
        }).finally(() => {
            setLoading(false);
        });
    }
    if(loading){
        return (
            <div className="mc-spinner">
                <img className="pattern" src="images/pattern.webp" alt="pattern" />
                <img className="favicon" src="images/logo.webp" alt="logo" />
                <div className="mc-spinner-group">
                    <h3>Loading</h3>
                    <PulseLoader 
                        color="#0857f5"
                        loading={loading} 
                        size={8} 
                    /> 
                </div>
            </div>
        );
    }else{
        return (
            <PageLayout>
                <Row>
                    <Col xl={12}>
                        <div className="mc-card">
                            <div className='mc-breadcrumb'>
                                <h3 className="mc-breadcrumb-title">{t('create_country')}</h3>
                            </div>
                        </div>
                    </Col>
                    <Col xl={12}>
                        <div className="mc-card">
                            <div className="mc-tab-card">
                            <Row>
                                <Col xl={12}><LabelFieldComponent type="text" label={t('country_name')} fieldSize="w-100 h-md" onChange={(e)=>setCountry(e.target.value)} value={country}/></Col>
                                <Col xl={12}><LabelFieldComponent disabled={country==''} type="text" label={t('city_name')} fieldSize="w-100 h-md" onChange={(e)=>setCity(e.target.value)} value={city}/></Col>

                            </Row>
                            <Row>
                                <Col xl={12}>
                                    <LabelFieldComponent disabled={city==''} type="text" label={t('state_name')} fieldSize="w-100 h-md" onChange={(e)=>setState(e.target.value)} value={state}/>
                                    <ButtonComponent disabled={city==''} className="mc-btn primary" icon="verified" text={t('add')} onClick={()=>handleAddState()}/>

                                </Col>
                                <Col xl={12}>
                                    <div className="mc-label-field-group label-col" style={{ marginTop: '20px' }}>
                                    {
                                        states.length>0 && states.map((stateItem, index) => (
                                            <Col key={index} xl={4}>
                                                <TextWithIconFieldComponent 
                                                    label={''} 
                                                    fieldSize="w-100 h-md" 
                                                    value={stateItem} 
                                                    readOnly
                                                    icon="delete"
                                                    iconAction={()=>setAlertModal(true,setCurrentStateIndex(index))}
                                                    />
                                            </Col>
                                        ))
                                    }
                                    </div>
                                </Col>
                                
                            </Row> 
                            </div>
                            
                            
                            <ButtonComponent className="mc-btn primary" icon="verified" text={t('create')} onClick={()=>handleSubmit()}/>
                               
                                
                        </div>
                    </Col>
                </Row>
                <Modal show={ alertModal } onHide={()=> setAlertModal(false,setCurrentStateIndex(0))}>
                    <div className="mc-alert-modal">
                        <i className="material-icons">new_releases</i>
                        <h3>are your sure!</h3>
                        <p>Want to delete this deals?</p>
                        <Modal.Footer>
                            <ButtonComponent type="button" className="btn btn-secondary" onClick={()=> setAlertModal(false)}>{t('close')}</ButtonComponent>
                            <ButtonComponent type="button" className="btn btn-danger" onClick={()=> {
                                const newStates = states.filter((item, i) => i !== currentStateIndex);
                                setStates(newStates);
                                setAlertModal(false,setCurrentStateIndex(0));
                            }}>{t('delete')}</ButtonComponent>
                        </Modal.Footer>
                    </div>
                </Modal>
            </PageLayout>
        )
    }
    
}